(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["se-localization-dialog"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('se-localization-dialog')) {
    customElements.define('se-localization-dialog', class extends HTMLElement {
      connectedCallback() {
        if (window.Shopify?.designMode) return;

        this.dialog = this.querySelector('[data-dialog]');
        this.form = this.querySelector('form');
        this.country = this.querySelector('[data-country]');
        this.language = this.querySelector('[data-language]');
        this.availableLanguages = new Map(JSON.parse(this.querySelector('[data-available-languages]').textContent).map(code => [code.toLowerCase(), code]));
        this.countryLanguages = {
          AR: 'es', BO: 'es', CL: 'es', CO: 'es', CR: 'es', CU: 'es', DO: 'es', EC: 'es', ES: 'es', GQ: 'es', GT: 'es', HN: 'es', MX: 'es', NI: 'es', PA: 'es', PE: 'es', PR: 'es', PY: 'es', SV: 'es', UY: 'es', VE: 'es',
          IT: 'it', SM: 'it', VA: 'it', FR: 'fr', MC: 'fr', DE: 'de', AT: 'de', LI: 'de', BR: 'pt-BR', PT: 'pt-BR', CN: 'zh-CN', SG: 'zh-CN', JP: 'ja', RU: 'ru', BY: 'ru', KZ: 'ru', AE: 'ar', BH: 'ar', DZ: 'ar', EG: 'ar', IQ: 'ar', JO: 'ar', KW: 'ar', LB: 'ar', LY: 'ar', MA: 'ar', OM: 'ar', QA: 'ar', SA: 'ar', SD: 'ar', SY: 'ar', TN: 'ar', YE: 'ar', KR: 'ko', IN: 'hi'
        };
        this.storageKey = 'se_localization_resolved_v2';

        this.querySelectorAll('[data-close]').forEach(button => {
          button.addEventListener('click', () => {
            this.remember('dismissed');
            this.dialog.close();
          });
        });

        this.dialog.addEventListener('cancel', () => this.remember('dismissed'));
        this.country.addEventListener('change', () => this.setLanguage(this.country.value));
        this.form.addEventListener('submit', () => this.remember(`${this.country.value}|${this.language.value}`));

        if (this.recalled()) return;
        this.detect();
      }

      setLanguage(countryCode) {
        const countryLanguage = this.countryLanguages[countryCode];
        const browserLanguages = navigator.languages?.length ? navigator.languages : [navigator.language];
        const candidates = countryLanguage ? [countryLanguage] : browserLanguages;
        const matched = candidates.map(code => {
          const normalized = String(code || '').toLowerCase();
          if (this.availableLanguages.has(normalized)) return this.availableLanguages.get(normalized);
          const baseMatch = [...this.availableLanguages.entries()].find(([available]) => available.split('-')[0] === normalized.split('-')[0]);
          return baseMatch?.[1];
        }).find(Boolean);
        this.language.value = matched || this.availableLanguages.get('en') || this.dataset.currentLanguage;
      }

      remember(value) {
        try { localStorage.setItem(this.storageKey, value); } catch (error) {}
      }

      recalled() {
        try { return Boolean(localStorage.getItem(this.storageKey)); } catch (error) { return false; }
      }

      open() {
        this.setLanguage(this.country.value);
        if (!this.dialog.open) this.dialog.showModal();
      }

      async detect() {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), 3000);

        try {
          const root = window.Shopify?.routes?.root || '/';
          const params = new URLSearchParams({
            'country[enabled]': 'true',
            'language[enabled]': 'true'
          });
          const response = await fetch(`${root}browsing_context_suggestions.json?${params}`, {
            signal: controller.signal,
            headers: { Accept: 'application/json' }
          });
          if (!response.ok) throw new Error('Localization detection failed');

          const data = await response.json();
          const detected = data?.detected_values?.country?.handle;
          const suggested = data?.suggestions?.[0]?.parts?.country?.handle;
          const countryCode = [detected, suggested].find(code => code && this.country.querySelector(`option[value="${CSS.escape(code)}"]`));

          if (!countryCode) {
            this.open();
            return;
          }

          this.country.value = countryCode;
          this.setLanguage(countryCode);
          const alreadyLocalized = countryCode === this.dataset.currentCountry && this.language.value === this.dataset.currentLanguage;
          this.remember(`${countryCode}|${this.language.value}`);
          if (!alreadyLocalized) this.form.requestSubmit();
        } catch (error) {
          this.open();
        } finally {
          clearTimeout(timer);
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["se-overlays"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('se-dialogs'))customElements.define('se-dialogs',class extends HTMLElement{
 connectedCallback(){this.abort=new AbortController();const options={signal:this.abort.signal};this.addEventListener('click',event=>{const trigger=event.target.closest('[data-se-dialog],[data-se-policy-url]');if(trigger){let source=trigger.dataset.seDialog?document.getElementById(trigger.dataset.seDialog):[...this.querySelectorAll('[data-policy-source-url]')].find(item=>item.dataset.policySourceUrl===trigger.dataset.sePolicyUrl);const dialog=this.querySelector('#SEOverlay');if(!source||!dialog||typeof dialog.showModal!=='function')return;event.preventDefault();this.opener=trigger;dialog.querySelector('#SEOverlayTitle').textContent=trigger.dataset.seTitle||trigger.textContent.trim();const body=dialog.querySelector('[data-se-overlay-body]');body.replaceChildren(...[...source.childNodes].map(node=>node.cloneNode(true)));body.querySelectorAll('[id]').forEach(node=>node.removeAttribute('id'));dialog.showModal();dialog.scrollTop=0;return}if(event.target.closest('[data-se-close]'))this.querySelector('#SEOverlay')?.close()},options);const dialog=this.querySelector('#SEOverlay');dialog?.addEventListener('close',()=>this.opener?.focus(),options);dialog?.addEventListener('click',event=>{if(event.target!==dialog)return;const r=dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)dialog.close()},options)}
 disconnectedCallback(){this.abort?.abort();this.querySelector('#SEOverlay')?.close()}
});
  } catch(e) { console.error(e); }
})();

})();
